import './index.scss'
$(document).ready(function () {
    $('.section1 .banner .swiper-slide').addClass('swiper-slide-active')
  });